import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const DOMAINS_FEATURE_GROUP: FeatureGroup = {
  guid: 'b4d26a01-8f3e-4c79-b725-0a1f94e3ff00',
  name: 'domains',
  description: 'Domain management features — register, view, edit, and remove domains',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
